import React, { Component } from 'react'
import ComHeader from './ComHeader'
import { Outlet } from "react-router-dom";
import ComFooter from './ComFooter';
import { Ribbon } from './shared/Ribbon';

export default class Layout extends Component {

    render() {
        const showRibbon = process.env.REACT_APP_ENV !== 'Production';

        return (
            <>
                <ComHeader />
                <main>
                    <Outlet />
                </main>
                <ComFooter />
                {showRibbon && <Ribbon />}
            </>
        )
    }
}
